module.exports = " <div style=height:100px;font-size:100px></div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/number-roller/index.vue
// module id = 231
// module chunks = 2